import { FormGroup } from '@angular/forms';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { SmartToastService } from '@shared/services/smart-toast.service';
import { getDatiBilancioControl } from '../validators/helpers/dati-bilancio-form.helpers';

const TOAST_ANNUAL_CERT = 'dati-bilancio.ck-ente-tenuto-cert-bil.annual-certification';

export const datiBilancioToastListeners = (form: FormGroup, smartToast: SmartToastService): void => {
    const control = getDatiBilancioControl(form, 'my_CkEnteTenutoCertBil');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((value) => {
        smartToast.notify({
            key: TOAST_ANNUAL_CERT,
            condition: value === '1',
            message: 'La cooperativa certificabile è revisionata annualmente.',
            type: 'info',
        });
    });
};
